angular.module('tgaAdmin').service('instructorService', [
  '$http',
  'envService',
  'domainService',
  function ($http, envService, domainService) {
    const serverAddress = envService.read('serverAddress');

    function getState(slug) {
      return $http({
        method: 'GET',
        url: `${serverAddress}instructor`,
        params: {
          slug,
        },
        cancelOnRouteChange: true,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function initiate(gameId, name, mode, game_mute) {
      return $http({
        method: 'POST',
        url: `${serverAddress}instructor/initiate/${gameId}`,
        data: {
          domain: domainService.domain,
          game_id: gameId,
          name,
          mode,
          game_mute,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function addInstructor(slug) {
      return $http({
        method: 'POST',
        url: `${serverAddress}instructor/add`,
        data: {
          domain: domainService.domain,
          slug,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function end(slug) {
      return $http({
        method: 'POST',
        url: `${serverAddress}instructor/end`,
        data: {
          domain: domainService.domain,
          slug,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function next(slug) {
      return $http({
        method: 'POST',
        url: `${serverAddress}instructor/next`,
        data: {
          domain: domainService.domain,
          slug,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function leaderboard(slug, show_leaderboard = null) {
      return $http({
        method: 'POST',
        url: `${serverAddress}instructor/leaderboard`,
        data: {
          domain: domainService.domain,
          slug,
          show_leaderboard,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getPlayers(params) {
      return $http({
        method: 'GET',
        url: `${serverAddress}instructor/players/${params.session_group_id}`,
        params,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getSessionGroup(game_id, session_group_id) {
      return $http({
        method: 'GET',
        url: `${serverAddress}instructor/sessiongroup`,
        params: {
          game_id,
          session_group_id,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getSessionGroups(gameId, startDate, endDate) {
      return $http({
        method: 'GET',
        url: `${serverAddress}instructor/sessiongroup`,
        params: {
          game_id: gameId,
          start_date: startDate,
          end_date: endDate,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getSessionGroupQuestionPlayerAnswers(session_group_id, question_id) {
      return $http({
        method: 'GET',
        url: `${serverAddress}instructor/sessionGroupAnswers/${session_group_id}`,
        params: {
          question_id,
        },
      });
    }

    function overrideAnswer(user_answer_id, correct) {
      return $http({
        method: 'POST',
        url: `${serverAddress}instructor/override`,
        data: {
          user_answer_id,
          correct,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getLiveSession(session_group_id) {
      return $http({
        method: 'GET',
        url: `${serverAddress}instructor/session_live/${session_group_id}`,
      }).then(
        (response) => response.data,
        (error) => Promise.reject(error),
      );
    }

    return {
      getState,
      initiate,
      addInstructor,
      end,
      next,
      leaderboard,
      getPlayers,
      getSessionGroup,
      getSessionGroups,
      getSessionGroupQuestionPlayerAnswers,
      overrideAnswer,
      getLiveSession,
    };
  },
]);
